import { GraphQLResolveInfo } from 'graphql';
import { ApolloContext } from '../apollo';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Alignment = {
  readonly __typename?: 'Alignment';
  readonly roll: Scalars['Float'];
  readonly pitch: Scalars['Float'];
  readonly yaw: Scalars['Float'];
};

export type AlignmentInput = {
  readonly roll: Scalars['Float'];
  readonly pitch: Scalars['Float'];
  readonly yaw: Scalars['Float'];
};

export type Arming = {
  readonly __typename?: 'Arming';
  readonly disabledFlags: ReadonlyArray<Scalars['Int']>;
};

export type Attitude = {
  readonly __typename?: 'Attitude';
  readonly roll: Scalars['Float'];
  readonly pitch: Scalars['Float'];
  readonly yaw: Scalars['Float'];
};

export type BandsRow = {
  readonly __typename?: 'BandsRow';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly letter: Scalars['String'];
  readonly isFactoryBand: Scalars['Boolean'];
  readonly frequencies: ReadonlyArray<Scalars['Int']>;
};

export type BandsRowInput = {
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly letter: Scalars['String'];
  readonly isFactoryBand: Scalars['Boolean'];
  readonly frequencies: ReadonlyArray<Scalars['Int']>;
};

export type BeeperConfig = {
  readonly __typename?: 'BeeperConfig';
  readonly conditions: ReadonlyArray<Scalars['Int']>;
  readonly dshot: DshotBeeperConfig;
};

export type Blackbox = {
  readonly __typename?: 'Blackbox';
  readonly supported: Scalars['Boolean'];
  readonly config: BlackboxConfig;
  readonly flash: BlackboxFlash;
  readonly sdCard: BlackboxSdCard;
};

export type BlackboxConfig = {
  readonly __typename?: 'BlackboxConfig';
  readonly device: Scalars['Int'];
  readonly rateNum: Scalars['Int'];
  readonly rateDenom: Scalars['Int'];
  readonly pDenom: Scalars['Int'];
  readonly sampleRate: Scalars['Int'];
};

export type BlackboxConfigInput = {
  readonly device?: Maybe<Scalars['Int']>;
  readonly rateNum?: Maybe<Scalars['Int']>;
  readonly rateDenom?: Maybe<Scalars['Int']>;
  readonly pDenom?: Maybe<Scalars['Int']>;
  readonly sampleRate?: Maybe<Scalars['Int']>;
};

export type BlackboxFlash = {
  readonly __typename?: 'BlackboxFlash';
  readonly ready: Scalars['Boolean'];
  readonly supported: Scalars['Boolean'];
  readonly sectors: Scalars['Int'];
  readonly totalSize: Scalars['Int'];
  readonly usedSize: Scalars['Int'];
};

export type BlackboxSdCard = {
  readonly __typename?: 'BlackboxSdCard';
  readonly supported: Scalars['Boolean'];
  readonly state: Scalars['Int'];
  readonly filesystemLastError: Scalars['Int'];
  readonly freeSizeKB: Scalars['Int'];
  readonly totalSizeKB: Scalars['Int'];
};

export type BoardInfo = {
  readonly __typename?: 'BoardInfo';
  readonly boardIdentifier: Scalars['String'];
  readonly boardVersion: Scalars['Int'];
  readonly boardType: Scalars['Int'];
  readonly targetCapabilities: ReadonlyArray<Scalars['Int']>;
  readonly targetName: Scalars['String'];
  readonly boardName: Scalars['String'];
  readonly manufacturerId: Scalars['String'];
  readonly signature: ReadonlyArray<Scalars['Int']>;
  readonly mcuTypeId: Scalars['Int'];
  readonly configurationState?: Maybe<Scalars['Int']>;
  readonly sampleRateHz?: Maybe<Scalars['Int']>;
};

export type Configurator = {
  readonly __typename?: 'Configurator';
  readonly logs: ReadonlyArray<Log>;
};

export type Connection = {
  readonly __typename?: 'Connection';
  readonly apiVersion: Scalars['String'];
  readonly baudRate: Scalars['Int'];
  readonly bytesRead: Scalars['Int'];
  readonly bytesWritten: Scalars['Int'];
  readonly device: FlightController;
  readonly id: Scalars['ID'];
  readonly packetErrors: Scalars['Int'];
  readonly port: Scalars['String'];
};

export type DshotBeeperConfig = {
  readonly __typename?: 'DshotBeeperConfig';
  readonly tone: Scalars['Int'];
  readonly conditions: ReadonlyArray<Scalars['Int']>;
};

export type DshotBeeperConfigInput = {
  readonly tone: Scalars['Int'];
  readonly conditions: ReadonlyArray<Scalars['Int']>;
};

export type FlightController = {
  readonly __typename?: 'FlightController';
  readonly alignment: Alignment;
  readonly arming: Arming;
  readonly attitude: Attitude;
  readonly beeper: BeeperConfig;
  readonly blackbox: Blackbox;
  readonly features: ReadonlyArray<Scalars['Int']>;
  readonly gps: GpsData;
  readonly info: BoardInfo;
  readonly modes: Modes;
  readonly motors: MotorsConfig;
  readonly name: Scalars['String'];
  readonly osd: OsdConfig;
  readonly pid: PidConfig;
  readonly power: Power;
  readonly profiles: Profiles;
  readonly rc: Rc;
  readonly sensors: Sensors;
  readonly serial: SerialConfig;
  readonly status: Status;
  readonly variant: Scalars['String'];
  readonly vtx: VtxConfig;
};

export type GpsData = {
  readonly __typename?: 'GpsData';
  readonly fix: Scalars['Boolean'];
  readonly numSat: Scalars['Int'];
  readonly lat: Scalars['Float'];
  readonly lon: Scalars['Float'];
  readonly alt: Scalars['Float'];
  readonly speed: Scalars['Float'];
  readonly groundCourse: Scalars['Float'];
};

export type JobArtifact = {
  readonly __typename?: 'JobArtifact';
  readonly id: Scalars['String'];
  readonly data: Scalars['String'];
};

export type JobDetails = {
  readonly __typename?: 'JobDetails';
  readonly id: Scalars['String'];
  readonly createdAt: Scalars['String'];
  readonly progress: Scalars['Int'];
  readonly error?: Maybe<JobError>;
  readonly completed: Scalars['Boolean'];
  readonly cancelled: Scalars['Boolean'];
  readonly artifact?: Maybe<JobArtifact>;
  readonly type: JobType;
  readonly connectionId?: Maybe<Scalars['String']>;
};

export type JobError = {
  readonly __typename?: 'JobError';
  readonly message: Scalars['String'];
  readonly code?: Maybe<Scalars['Int']>;
};

export enum JobType {
  Offload = 'OFFLOAD',
  General = 'GENERAL'
}

export type JobUpdate = {
  readonly __typename?: 'JobUpdate';
  readonly type: JobUpdateType;
  readonly details: JobDetails;
};

export enum JobUpdateType {
  New = 'NEW',
  Changed = 'CHANGED',
  Removed = 'REMOVED'
}

export type LegacyBaudRates = {
  readonly __typename?: 'LegacyBaudRates';
  readonly mspBaudRate: Scalars['Int'];
  readonly cliBaudRate: Scalars['Int'];
  readonly gpsBaudRate: Scalars['Int'];
  readonly gpsPassthroughBaudRate: Scalars['Int'];
};

export type Log = {
  readonly __typename?: 'Log';
  readonly time: Scalars['String'];
  readonly message: Scalars['String'];
};

export type ModeActivationRange = {
  readonly __typename?: 'ModeActivationRange';
  readonly start: Scalars['Int'];
  readonly end: Scalars['Int'];
};

export type ModeActivationRangeInput = {
  readonly start: Scalars['Int'];
  readonly end: Scalars['Int'];
};

export type ModeSlot = {
  readonly __typename?: 'ModeSlot';
  readonly id: Scalars['Int'];
  readonly modeId: Scalars['Int'];
  readonly auxChannel: Scalars['Int'];
  readonly range: ModeActivationRange;
  readonly modeLogic?: Maybe<Scalars['Int']>;
  readonly linkedTo?: Maybe<Scalars['Int']>;
};

export type ModeSlotConfig = {
  readonly modeId: Scalars['Int'];
  readonly auxChannel: Scalars['Int'];
  readonly range: ModeActivationRangeInput;
  readonly modeLogic?: Maybe<Scalars['Int']>;
  readonly linkedTo?: Maybe<Scalars['Int']>;
};

export type Modes = {
  readonly __typename?: 'Modes';
  readonly available: ReadonlyArray<Scalars['Int']>;
  readonly slots: ReadonlyArray<ModeSlot>;
  readonly slot?: Maybe<ModeSlot>;
};


export type ModesSlotArgs = {
  id: Scalars['Int'];
};

export type MotorsConfig = {
  readonly __typename?: 'MotorsConfig';
  readonly mixer: Scalars['Int'];
  readonly reversedDirection: Scalars['Boolean'];
  readonly digitalIdlePercent: Scalars['Float'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly cancelJob?: Maybe<Scalars['Boolean']>;
  readonly close: Scalars['ID'];
  readonly connect: Connection;
  readonly createFlashDataOffloadJob: JobDetails;
  readonly deviceCallibrateAccelerometer?: Maybe<Scalars['Boolean']>;
  readonly deviceClearVtxTable?: Maybe<Scalars['Boolean']>;
  readonly deviceEraseFlashData?: Maybe<Scalars['Boolean']>;
  readonly deviceReset?: Maybe<Scalars['Boolean']>;
  readonly deviceSetArming?: Maybe<Scalars['Boolean']>;
  readonly deviceSetBlackboxConfig?: Maybe<Scalars['Boolean']>;
  readonly deviceSetBoardAlignment?: Maybe<Scalars['Boolean']>;
  readonly deviceSetChannelMap?: Maybe<Scalars['Boolean']>;
  readonly deviceSetDigitalIdleSpeed?: Maybe<Scalars['Boolean']>;
  readonly deviceSetDisabledSensors?: Maybe<Scalars['Boolean']>;
  readonly deviceSetDshotBeeperConfig?: Maybe<Scalars['Boolean']>;
  readonly deviceSetFeatures?: Maybe<Scalars['Boolean']>;
  readonly deviceSetModeSlotConfig?: Maybe<Scalars['Boolean']>;
  readonly deviceSetMotorsDirection?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDAlarm?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDChar?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDDisplayItem?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDParameters?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDProfile?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDStatisticItem?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDTimer?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDUnitMode?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDVideoSystem?: Maybe<Scalars['Boolean']>;
  readonly deviceSetOSDWarning?: Maybe<Scalars['Boolean']>;
  readonly deviceSetPidProtocols?: Maybe<Scalars['Boolean']>;
  readonly deviceSetRcSmoothingConfig?: Maybe<Scalars['Boolean']>;
  readonly deviceSetReceiverConfig?: Maybe<Scalars['Boolean']>;
  readonly deviceSetRssiChannel?: Maybe<Scalars['Boolean']>;
  readonly deviceSetSerialFunctions?: Maybe<Scalars['Boolean']>;
  readonly deviceSetVtxConfig?: Maybe<Scalars['Boolean']>;
  readonly deviceSetVtxTableBandsRow?: Maybe<Scalars['Boolean']>;
  readonly deviceSetVtxTablePowerLevelsRow?: Maybe<Scalars['Boolean']>;
  readonly log?: Maybe<Scalars['Boolean']>;
};


export type MutationCancelJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCloseArgs = {
  connectionId: Scalars['ID'];
};


export type MutationConnectArgs = {
  port: Scalars['String'];
  baudRate: Scalars['Int'];
};


export type MutationCreateFlashDataOffloadJobArgs = {
  connectionId: Scalars['ID'];
  chunkSize: Scalars['Int'];
};


export type MutationDeviceCallibrateAccelerometerArgs = {
  connectionId: Scalars['ID'];
};


export type MutationDeviceClearVtxTableArgs = {
  connectionId: Scalars['ID'];
};


export type MutationDeviceEraseFlashDataArgs = {
  connectionId: Scalars['ID'];
};


export type MutationDeviceResetArgs = {
  connectionId: Scalars['ID'];
};


export type MutationDeviceSetArmingArgs = {
  connectionId: Scalars['ID'];
  armingDisabled: Scalars['Boolean'];
  runawayTakeoffPreventionDisabled: Scalars['Boolean'];
};


export type MutationDeviceSetBlackboxConfigArgs = {
  connectionId: Scalars['ID'];
  config: BlackboxConfigInput;
};


export type MutationDeviceSetBoardAlignmentArgs = {
  connectionId: Scalars['ID'];
  alignment: AlignmentInput;
};


export type MutationDeviceSetChannelMapArgs = {
  connectionId: Scalars['ID'];
  channelMap: ReadonlyArray<Scalars['ID']>;
};


export type MutationDeviceSetDigitalIdleSpeedArgs = {
  connectionId: Scalars['ID'];
  idlePercentage: Scalars['Float'];
};


export type MutationDeviceSetDisabledSensorsArgs = {
  connectionId: Scalars['ID'];
  disabledSensors: ReadonlyArray<Scalars['Int']>;
};


export type MutationDeviceSetDshotBeeperConfigArgs = {
  connectionId: Scalars['ID'];
  config: DshotBeeperConfigInput;
};


export type MutationDeviceSetFeaturesArgs = {
  connectionId: Scalars['ID'];
  features: ReadonlyArray<Scalars['Int']>;
};


export type MutationDeviceSetModeSlotConfigArgs = {
  connectionId: Scalars['ID'];
  slotId: Scalars['Int'];
  config: ModeSlotConfig;
};


export type MutationDeviceSetMotorsDirectionArgs = {
  connectionId: Scalars['ID'];
  reversed: Scalars['Boolean'];
};


export type MutationDeviceSetOsdAlarmArgs = {
  connectionId: Scalars['ID'];
  alarm: OsdAlarmInput;
};


export type MutationDeviceSetOsdCharArgs = {
  connectionId: Scalars['ID'];
  charIndex: Scalars['Int'];
  charBytesBuffer: ReadonlyArray<Scalars['Int']>;
};


export type MutationDeviceSetOsdDisplayItemArgs = {
  connectionId: Scalars['ID'];
  displayItem: OsdDisplayItemInput;
};


export type MutationDeviceSetOsdParametersArgs = {
  connectionId: Scalars['ID'];
  parameters: OsdParametersInput;
};


export type MutationDeviceSetOsdProfileArgs = {
  connectionId: Scalars['ID'];
  profileIndex: Scalars['Int'];
};


export type MutationDeviceSetOsdStatisticItemArgs = {
  connectionId: Scalars['ID'];
  statisticItem: OsdStatisticItemInput;
};


export type MutationDeviceSetOsdTimerArgs = {
  connectionId: Scalars['ID'];
  timer: OsdTimerInput;
};


export type MutationDeviceSetOsdUnitModeArgs = {
  connectionId: Scalars['ID'];
  unitMode: Scalars['Int'];
};


export type MutationDeviceSetOsdVideoSystemArgs = {
  connectionId: Scalars['ID'];
  videoSystem: Scalars['Int'];
};


export type MutationDeviceSetOsdWarningArgs = {
  connectionId: Scalars['ID'];
  warning: OsdWarningInput;
};


export type MutationDeviceSetPidProtocolsArgs = {
  connectionId: Scalars['ID'];
  protocols: PidProtocolsInput;
};


export type MutationDeviceSetRcSmoothingConfigArgs = {
  connectionId: Scalars['ID'];
  smoothingConfig: RcSmoothingInput;
};


export type MutationDeviceSetReceiverConfigArgs = {
  connectionId: Scalars['ID'];
  receiverConfig: RxConfigInput;
};


export type MutationDeviceSetRssiChannelArgs = {
  connectionId: Scalars['ID'];
  channel: Scalars['Int'];
};


export type MutationDeviceSetSerialFunctionsArgs = {
  connectionId: Scalars['ID'];
  portFunctions: ReadonlyArray<PortFunctionsInput>;
};


export type MutationDeviceSetVtxConfigArgs = {
  connectionId: Scalars['ID'];
  vtxConfig: VtxConfigInput;
};


export type MutationDeviceSetVtxTableBandsRowArgs = {
  connectionId: Scalars['ID'];
  bandsRow: BandsRowInput;
};


export type MutationDeviceSetVtxTablePowerLevelsRowArgs = {
  connectionId: Scalars['ID'];
  powerLevelsRow: PowerLevelsRowInput;
};


export type MutationLogArgs = {
  message: Scalars['String'];
};

export type OsdAlarm = {
  readonly __typename?: 'OSDAlarm';
  readonly id: Scalars['Int'];
  readonly value: Scalars['Int'];
};

export type OsdAlarmInput = {
  readonly id: Scalars['Int'];
  readonly value: Scalars['Int'];
};

export type OsdConfig = {
  readonly __typename?: 'OSDConfig';
  readonly flags: OsdFlags;
  readonly unitMode: Scalars['Int'];
  readonly displayItems: ReadonlyArray<OsdDisplayItem>;
  readonly statisticItems: ReadonlyArray<OsdStatisticItem>;
  readonly warnings: ReadonlyArray<OsdWarning>;
  readonly timers: ReadonlyArray<OsdTimer>;
  readonly osdProfiles: OsdProfileConfig;
  readonly videoSystem: Scalars['Int'];
  readonly alarms: ReadonlyArray<OsdAlarm>;
  readonly parameters: OsdParameters;
};

export type OsdDisplayItem = {
  readonly __typename?: 'OSDDisplayItem';
  readonly id: Scalars['Int'];
  readonly position: OsdPosition;
  readonly visibilityProfiles: ReadonlyArray<Scalars['Boolean']>;
};

export type OsdDisplayItemInput = {
  readonly id: Scalars['Int'];
  readonly position: OsdPositionInput;
  readonly visibilityProfiles: ReadonlyArray<Scalars['Boolean']>;
};

export type OsdFlags = {
  readonly __typename?: 'OSDFlags';
  readonly hasOSD: Scalars['Boolean'];
  readonly haveMax7456Video: Scalars['Boolean'];
  readonly haveOsdFeature: Scalars['Boolean'];
  readonly isOsdSlave: Scalars['Boolean'];
  readonly isMax7456Detected: Scalars['Boolean'];
};

export type OsdParameters = {
  readonly __typename?: 'OSDParameters';
  readonly cameraFrameWidth: Scalars['Int'];
  readonly cameraFrameHeight: Scalars['Int'];
  readonly overlayRadioMode: Scalars['Int'];
};

export type OsdParametersInput = {
  readonly cameraFrameWidth?: Maybe<Scalars['Int']>;
  readonly cameraFrameHeight?: Maybe<Scalars['Int']>;
  readonly overlayRadioMode?: Maybe<Scalars['Int']>;
};

export type OsdPosition = {
  readonly __typename?: 'OSDPosition';
  readonly x: Scalars['Int'];
  readonly y: Scalars['Int'];
};

export type OsdPositionInput = {
  readonly x: Scalars['Int'];
  readonly y: Scalars['Int'];
};

export type OsdProfileConfig = {
  readonly __typename?: 'OSDProfileConfig';
  readonly count: Scalars['Int'];
  readonly selected: Scalars['Int'];
};

export type OsdStatisticItem = {
  readonly __typename?: 'OSDStatisticItem';
  readonly id: Scalars['Int'];
  readonly enabled: Scalars['Boolean'];
};

export type OsdStatisticItemInput = {
  readonly id: Scalars['Int'];
  readonly enabled: Scalars['Boolean'];
};

export type OsdTimer = {
  readonly __typename?: 'OSDTimer';
  readonly id: Scalars['Int'];
  readonly src: Scalars['Int'];
  readonly precision: Scalars['Int'];
  readonly time: Scalars['Int'];
};

export type OsdTimerInput = {
  readonly id: Scalars['Int'];
  readonly src: Scalars['Int'];
  readonly precision: Scalars['Int'];
  readonly time: Scalars['Int'];
};

export type OsdWarning = {
  readonly __typename?: 'OSDWarning';
  readonly id: Scalars['Int'];
  readonly enabled: Scalars['Boolean'];
};

export type OsdWarningInput = {
  readonly id: Scalars['Int'];
  readonly enabled: Scalars['Boolean'];
};

export type OffloadJobError = {
  readonly __typename?: 'OffloadJobError';
  readonly message: Scalars['String'];
};

export type PidConfig = {
  readonly __typename?: 'PidConfig';
  readonly protocols: PidProtocols;
};

export type PidProtocols = {
  readonly __typename?: 'PidProtocols';
  readonly gyroSyncDenom: Scalars['Int'];
  readonly pidProcessDenom: Scalars['Int'];
  readonly useUnsyncedPwm: Scalars['Boolean'];
  readonly fastPwmProtocol: Scalars['Int'];
  readonly gyroUse32kHz: Scalars['Boolean'];
  readonly motorPwmRate: Scalars['Int'];
};

export type PidProtocolsInput = {
  readonly gyroSyncDenom?: Maybe<Scalars['Int']>;
  readonly pidProcessDenom?: Maybe<Scalars['Int']>;
  readonly useUnsyncedPwm?: Maybe<Scalars['Boolean']>;
  readonly fastPwmProtocol?: Maybe<Scalars['Int']>;
  readonly gyroUse32kHz?: Maybe<Scalars['Boolean']>;
  readonly motorPwmRate?: Maybe<Scalars['Int']>;
};

export type Port = {
  readonly __typename?: 'Port';
  readonly id: Scalars['String'];
  readonly connecting: Scalars['Boolean'];
  readonly connectionId?: Maybe<Scalars['String']>;
  readonly manufacturer?: Maybe<Scalars['String']>;
  readonly serialNumber?: Maybe<Scalars['String']>;
  readonly pnpId?: Maybe<Scalars['String']>;
  readonly locationId?: Maybe<Scalars['String']>;
  readonly productId?: Maybe<Scalars['String']>;
  readonly vendorId?: Maybe<Scalars['String']>;
};

export type PortFunctionsInput = {
  readonly id: Scalars['Int'];
  readonly functions: ReadonlyArray<Scalars['Int']>;
};

export type PortSettings = {
  readonly __typename?: 'PortSettings';
  readonly id: Scalars['Int'];
  readonly functions: ReadonlyArray<Scalars['Int']>;
  readonly mspBaudRate: Scalars['Int'];
  readonly gpsBaudRate: Scalars['Int'];
  readonly telemetryBaudRate: Scalars['Int'];
  readonly blackboxBaudRate: Scalars['Int'];
};

export type Power = {
  readonly __typename?: 'Power';
  readonly voltage: Scalars['Float'];
  readonly mahDrawn: Scalars['Int'];
  readonly amperage: Scalars['Float'];
};

export type PowerLevelsRow = {
  readonly __typename?: 'PowerLevelsRow';
  readonly id: Scalars['Int'];
  readonly value: Scalars['Int'];
  readonly label: Scalars['String'];
};

export type PowerLevelsRowInput = {
  readonly id: Scalars['Int'];
  readonly value: Scalars['Int'];
  readonly label: Scalars['String'];
};

export type Profiles = {
  readonly __typename?: 'Profiles';
  readonly length: Scalars['Int'];
  readonly selected: Scalars['Int'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly configurator: Configurator;
  readonly connection: Connection;
  readonly dummy?: Maybe<Scalars['Boolean']>;
  readonly job?: Maybe<JobDetails>;
  readonly jobs: ReadonlyArray<JobDetails>;
  readonly port?: Maybe<Port>;
  readonly ports: ReadonlyArray<Port>;
};


export type QueryConnectionArgs = {
  connectionId: Scalars['ID'];
};


export type QueryJobArgs = {
  id: Scalars['ID'];
};


export type QueryJobsArgs = {
  ofType?: Maybe<JobType>;
};


export type QueryPortArgs = {
  id: Scalars['String'];
};

export type Rc = {
  readonly __typename?: 'RC';
  readonly channels: ReadonlyArray<Scalars['Int']>;
  readonly tuning: RcTuning;
  readonly smoothing: RcSmoothing;
  readonly deadband: RcDeadband;
  readonly rssi: RcRssi;
  readonly receiver: RxConfig;
};

export type RcDeadband = {
  readonly __typename?: 'RCDeadband';
  readonly deadband: Scalars['Int'];
  readonly yawDeadband: Scalars['Int'];
  readonly altHoldDeadhand: Scalars['Int'];
  readonly deadband3dThrottle: Scalars['Int'];
};

export type RcTuning = {
  readonly __typename?: 'RCTuning';
  readonly rcRate: Scalars['Float'];
  readonly rcExpo: Scalars['Float'];
  readonly rollPitchRate: Scalars['Float'];
  readonly pitchRate: Scalars['Float'];
  readonly rollRate: Scalars['Float'];
  readonly yawRate: Scalars['Float'];
  readonly dynamicThrottlePid: Scalars['Float'];
  readonly throttleMid: Scalars['Float'];
  readonly throttleExpo: Scalars['Float'];
  readonly dynamicThrottleBreakpoint: Scalars['Float'];
  readonly rcYawExpo: Scalars['Float'];
  readonly rcYawRate: Scalars['Float'];
  readonly rcPitchRate: Scalars['Float'];
  readonly rcPitchExpo: Scalars['Float'];
  readonly throttleLimitType: Scalars['Float'];
  readonly throttleLimitPercent: Scalars['Float'];
  readonly rollRateLimit: Scalars['Float'];
  readonly pitchRateLimit: Scalars['Float'];
  readonly yawRateLimit: Scalars['Float'];
};

export type RcRssi = {
  readonly __typename?: 'RcRssi';
  readonly value: Scalars['Int'];
  readonly channel: Scalars['Int'];
};

export type RcSmoothing = {
  readonly __typename?: 'RcSmoothing';
  readonly channels: Scalars['Int'];
  readonly type: Scalars['Int'];
  readonly inputCutoff: Scalars['Int'];
  readonly derivativeCutoff: Scalars['Int'];
  readonly inputType: Scalars['Int'];
  readonly derivativeType: Scalars['Int'];
  readonly autoSmoothness: Scalars['Int'];
};

export type RcSmoothingInput = {
  readonly channels?: Maybe<Scalars['Int']>;
  readonly type?: Maybe<Scalars['Int']>;
  readonly inputCutoff?: Maybe<Scalars['Int']>;
  readonly derivativeCutoff?: Maybe<Scalars['Int']>;
  readonly inputType?: Maybe<Scalars['Int']>;
  readonly derivativeType?: Maybe<Scalars['Int']>;
  readonly autoSmoothness?: Maybe<Scalars['Int']>;
};

export type RxConfig = {
  readonly __typename?: 'RxConfig';
  readonly serialProvider: Scalars['Int'];
  readonly spi: RxSpiConfig;
  readonly channelMap: ReadonlyArray<Scalars['ID']>;
};

export type RxConfigInput = {
  readonly serialProvider?: Maybe<Scalars['Int']>;
  readonly spi?: Maybe<RxSpiConfigInput>;
};

export type RxSpiConfig = {
  readonly __typename?: 'RxSpiConfig';
  readonly protocol: Scalars['Int'];
};

export type RxSpiConfigInput = {
  readonly protocol?: Maybe<Scalars['Int']>;
};

export type Sensors = {
  readonly __typename?: 'Sensors';
  readonly available: ReadonlyArray<Scalars['Int']>;
  readonly disabled: ReadonlyArray<Scalars['Int']>;
};

export type SerialConfig = {
  readonly __typename?: 'SerialConfig';
  readonly ports: ReadonlyArray<PortSettings>;
  readonly legacy?: Maybe<LegacyBaudRates>;
};

export type Status = {
  readonly __typename?: 'Status';
  readonly cycleTime: Scalars['Int'];
  readonly i2cError: Scalars['Int'];
  readonly cpuload: Scalars['Float'];
};

export type Subscription = {
  readonly __typename?: 'Subscription';
  readonly jobUpdates: JobUpdate;
  readonly onConnectionChanged?: Maybe<Scalars['ID']>;
  readonly onReconnecting: Scalars['ID'];
};


export type SubscriptionJobUpdatesArgs = {
  jobId?: Maybe<Scalars['ID']>;
  ofType?: Maybe<JobType>;
};


export type SubscriptionOnConnectionChangedArgs = {
  connectionId: Scalars['ID'];
};


export type SubscriptionOnReconnectingArgs = {
  connectionId: Scalars['ID'];
};

export type VtxConfig = {
  readonly __typename?: 'VtxConfig';
  readonly type: Scalars['Int'];
  readonly band: Scalars['Int'];
  readonly channel: Scalars['Int'];
  readonly power: Scalars['Int'];
  readonly pitMode: Scalars['Boolean'];
  readonly frequency: Scalars['Int'];
  readonly deviceReady: Scalars['Boolean'];
  readonly lowPowerDisarm: Scalars['Int'];
  readonly pitModeFrequency: Scalars['Int'];
  readonly table?: Maybe<VtxTableConfig>;
};

export type VtxConfigInput = {
  readonly type?: Maybe<Scalars['Int']>;
  readonly band?: Maybe<Scalars['Int']>;
  readonly channel?: Maybe<Scalars['Int']>;
  readonly power?: Maybe<Scalars['Int']>;
  readonly pitMode?: Maybe<Scalars['Boolean']>;
  readonly frequency?: Maybe<Scalars['Int']>;
  readonly deviceReady?: Maybe<Scalars['Boolean']>;
  readonly lowPowerDisarm?: Maybe<Scalars['Int']>;
  readonly pitModeFrequency?: Maybe<Scalars['Int']>;
  readonly table?: Maybe<VtxTableConfigInput>;
};

export type VtxTableConfig = {
  readonly __typename?: 'VtxTableConfig';
  readonly numBandChannels: Scalars['Int'];
  readonly numPowerLevels: Scalars['Int'];
  readonly powerLevels: ReadonlyArray<PowerLevelsRow>;
  readonly powerLevel?: Maybe<PowerLevelsRow>;
  readonly numBands: Scalars['Int'];
  readonly bands: ReadonlyArray<BandsRow>;
  readonly band?: Maybe<BandsRow>;
};


export type VtxTableConfigPowerLevelArgs = {
  id: Scalars['Int'];
};


export type VtxTableConfigBandArgs = {
  id: Scalars['Int'];
};

export type VtxTableConfigInput = {
  readonly numBandChannels: Scalars['Int'];
  readonly bands: ReadonlyArray<BandsRowInput>;
  readonly powerLevels: ReadonlyArray<PowerLevelsRowInput>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Alignment: ResolverTypeWrapper<Alignment>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  AlignmentInput: AlignmentInput;
  Arming: ResolverTypeWrapper<Arming>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Attitude: ResolverTypeWrapper<Attitude>;
  BandsRow: ResolverTypeWrapper<BandsRow>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BandsRowInput: BandsRowInput;
  BeeperConfig: ResolverTypeWrapper<BeeperConfig>;
  Blackbox: ResolverTypeWrapper<Blackbox>;
  BlackboxConfig: ResolverTypeWrapper<BlackboxConfig>;
  BlackboxConfigInput: BlackboxConfigInput;
  BlackboxFlash: ResolverTypeWrapper<BlackboxFlash>;
  BlackboxSdCard: ResolverTypeWrapper<BlackboxSdCard>;
  BoardInfo: ResolverTypeWrapper<BoardInfo>;
  Configurator: ResolverTypeWrapper<Configurator>;
  Connection: ResolverTypeWrapper<Connection>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  DshotBeeperConfig: ResolverTypeWrapper<DshotBeeperConfig>;
  DshotBeeperConfigInput: DshotBeeperConfigInput;
  FlightController: ResolverTypeWrapper<FlightController>;
  GpsData: ResolverTypeWrapper<GpsData>;
  JobArtifact: ResolverTypeWrapper<JobArtifact>;
  JobDetails: ResolverTypeWrapper<JobDetails>;
  JobError: ResolverTypeWrapper<JobError>;
  JobType: JobType;
  JobUpdate: ResolverTypeWrapper<JobUpdate>;
  JobUpdateType: JobUpdateType;
  LegacyBaudRates: ResolverTypeWrapper<LegacyBaudRates>;
  Log: ResolverTypeWrapper<Log>;
  ModeActivationRange: ResolverTypeWrapper<ModeActivationRange>;
  ModeActivationRangeInput: ModeActivationRangeInput;
  ModeSlot: ResolverTypeWrapper<ModeSlot>;
  ModeSlotConfig: ModeSlotConfig;
  Modes: ResolverTypeWrapper<Modes>;
  MotorsConfig: ResolverTypeWrapper<MotorsConfig>;
  Mutation: ResolverTypeWrapper<{}>;
  OSDAlarm: ResolverTypeWrapper<OsdAlarm>;
  OSDAlarmInput: OsdAlarmInput;
  OSDConfig: ResolverTypeWrapper<OsdConfig>;
  OSDDisplayItem: ResolverTypeWrapper<OsdDisplayItem>;
  OSDDisplayItemInput: OsdDisplayItemInput;
  OSDFlags: ResolverTypeWrapper<OsdFlags>;
  OSDParameters: ResolverTypeWrapper<OsdParameters>;
  OSDParametersInput: OsdParametersInput;
  OSDPosition: ResolverTypeWrapper<OsdPosition>;
  OSDPositionInput: OsdPositionInput;
  OSDProfileConfig: ResolverTypeWrapper<OsdProfileConfig>;
  OSDStatisticItem: ResolverTypeWrapper<OsdStatisticItem>;
  OSDStatisticItemInput: OsdStatisticItemInput;
  OSDTimer: ResolverTypeWrapper<OsdTimer>;
  OSDTimerInput: OsdTimerInput;
  OSDWarning: ResolverTypeWrapper<OsdWarning>;
  OSDWarningInput: OsdWarningInput;
  OffloadJobError: ResolverTypeWrapper<OffloadJobError>;
  PidConfig: ResolverTypeWrapper<PidConfig>;
  PidProtocols: ResolverTypeWrapper<PidProtocols>;
  PidProtocolsInput: PidProtocolsInput;
  Port: ResolverTypeWrapper<Port>;
  PortFunctionsInput: PortFunctionsInput;
  PortSettings: ResolverTypeWrapper<PortSettings>;
  Power: ResolverTypeWrapper<Power>;
  PowerLevelsRow: ResolverTypeWrapper<PowerLevelsRow>;
  PowerLevelsRowInput: PowerLevelsRowInput;
  Profiles: ResolverTypeWrapper<Profiles>;
  Query: ResolverTypeWrapper<{}>;
  RC: ResolverTypeWrapper<Rc>;
  RCDeadband: ResolverTypeWrapper<RcDeadband>;
  RCTuning: ResolverTypeWrapper<RcTuning>;
  RcRssi: ResolverTypeWrapper<RcRssi>;
  RcSmoothing: ResolverTypeWrapper<RcSmoothing>;
  RcSmoothingInput: RcSmoothingInput;
  RxConfig: ResolverTypeWrapper<RxConfig>;
  RxConfigInput: RxConfigInput;
  RxSpiConfig: ResolverTypeWrapper<RxSpiConfig>;
  RxSpiConfigInput: RxSpiConfigInput;
  Sensors: ResolverTypeWrapper<Sensors>;
  SerialConfig: ResolverTypeWrapper<SerialConfig>;
  Status: ResolverTypeWrapper<Status>;
  Subscription: ResolverTypeWrapper<{}>;
  VtxConfig: ResolverTypeWrapper<VtxConfig>;
  VtxConfigInput: VtxConfigInput;
  VtxTableConfig: ResolverTypeWrapper<VtxTableConfig>;
  VtxTableConfigInput: VtxTableConfigInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Alignment: Alignment;
  Float: Scalars['Float'];
  AlignmentInput: AlignmentInput;
  Arming: Arming;
  Int: Scalars['Int'];
  Attitude: Attitude;
  BandsRow: BandsRow;
  String: Scalars['String'];
  Boolean: Scalars['Boolean'];
  BandsRowInput: BandsRowInput;
  BeeperConfig: BeeperConfig;
  Blackbox: Blackbox;
  BlackboxConfig: BlackboxConfig;
  BlackboxConfigInput: BlackboxConfigInput;
  BlackboxFlash: BlackboxFlash;
  BlackboxSdCard: BlackboxSdCard;
  BoardInfo: BoardInfo;
  Configurator: Configurator;
  Connection: Connection;
  ID: Scalars['ID'];
  DshotBeeperConfig: DshotBeeperConfig;
  DshotBeeperConfigInput: DshotBeeperConfigInput;
  FlightController: FlightController;
  GpsData: GpsData;
  JobArtifact: JobArtifact;
  JobDetails: JobDetails;
  JobError: JobError;
  JobUpdate: JobUpdate;
  LegacyBaudRates: LegacyBaudRates;
  Log: Log;
  ModeActivationRange: ModeActivationRange;
  ModeActivationRangeInput: ModeActivationRangeInput;
  ModeSlot: ModeSlot;
  ModeSlotConfig: ModeSlotConfig;
  Modes: Modes;
  MotorsConfig: MotorsConfig;
  Mutation: {};
  OSDAlarm: OsdAlarm;
  OSDAlarmInput: OsdAlarmInput;
  OSDConfig: OsdConfig;
  OSDDisplayItem: OsdDisplayItem;
  OSDDisplayItemInput: OsdDisplayItemInput;
  OSDFlags: OsdFlags;
  OSDParameters: OsdParameters;
  OSDParametersInput: OsdParametersInput;
  OSDPosition: OsdPosition;
  OSDPositionInput: OsdPositionInput;
  OSDProfileConfig: OsdProfileConfig;
  OSDStatisticItem: OsdStatisticItem;
  OSDStatisticItemInput: OsdStatisticItemInput;
  OSDTimer: OsdTimer;
  OSDTimerInput: OsdTimerInput;
  OSDWarning: OsdWarning;
  OSDWarningInput: OsdWarningInput;
  OffloadJobError: OffloadJobError;
  PidConfig: PidConfig;
  PidProtocols: PidProtocols;
  PidProtocolsInput: PidProtocolsInput;
  Port: Port;
  PortFunctionsInput: PortFunctionsInput;
  PortSettings: PortSettings;
  Power: Power;
  PowerLevelsRow: PowerLevelsRow;
  PowerLevelsRowInput: PowerLevelsRowInput;
  Profiles: Profiles;
  Query: {};
  RC: Rc;
  RCDeadband: RcDeadband;
  RCTuning: RcTuning;
  RcRssi: RcRssi;
  RcSmoothing: RcSmoothing;
  RcSmoothingInput: RcSmoothingInput;
  RxConfig: RxConfig;
  RxConfigInput: RxConfigInput;
  RxSpiConfig: RxSpiConfig;
  RxSpiConfigInput: RxSpiConfigInput;
  Sensors: Sensors;
  SerialConfig: SerialConfig;
  Status: Status;
  Subscription: {};
  VtxConfig: VtxConfig;
  VtxConfigInput: VtxConfigInput;
  VtxTableConfig: VtxTableConfig;
  VtxTableConfigInput: VtxTableConfigInput;
};

export type AlignmentResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Alignment'] = ResolversParentTypes['Alignment']> = {
  roll?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pitch?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  yaw?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ArmingResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Arming'] = ResolversParentTypes['Arming']> = {
  disabledFlags?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttitudeResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Attitude'] = ResolversParentTypes['Attitude']> = {
  roll?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pitch?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  yaw?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BandsRowResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['BandsRow'] = ResolversParentTypes['BandsRow']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  letter?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isFactoryBand?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  frequencies?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeeperConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['BeeperConfig'] = ResolversParentTypes['BeeperConfig']> = {
  conditions?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  dshot?: Resolver<ResolversTypes['DshotBeeperConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlackboxResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Blackbox'] = ResolversParentTypes['Blackbox']> = {
  supported?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  config?: Resolver<ResolversTypes['BlackboxConfig'], ParentType, ContextType>;
  flash?: Resolver<ResolversTypes['BlackboxFlash'], ParentType, ContextType>;
  sdCard?: Resolver<ResolversTypes['BlackboxSdCard'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlackboxConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['BlackboxConfig'] = ResolversParentTypes['BlackboxConfig']> = {
  device?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rateNum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rateDenom?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pDenom?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sampleRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlackboxFlashResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['BlackboxFlash'] = ResolversParentTypes['BlackboxFlash']> = {
  ready?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  supported?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  usedSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlackboxSdCardResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['BlackboxSdCard'] = ResolversParentTypes['BlackboxSdCard']> = {
  supported?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  filesystemLastError?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  freeSizeKB?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalSizeKB?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoardInfoResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['BoardInfo'] = ResolversParentTypes['BoardInfo']> = {
  boardIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  boardVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  boardType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  targetCapabilities?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  targetName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  boardName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  manufacturerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signature?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  mcuTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  configurationState?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sampleRateHz?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfiguratorResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Configurator'] = ResolversParentTypes['Configurator']> = {
  logs?: Resolver<ReadonlyArray<ResolversTypes['Log']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Connection'] = ResolversParentTypes['Connection']> = {
  apiVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bytesRead?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bytesWritten?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  device?: Resolver<ResolversTypes['FlightController'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  packetErrors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  port?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DshotBeeperConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['DshotBeeperConfig'] = ResolversParentTypes['DshotBeeperConfig']> = {
  tone?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  conditions?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlightControllerResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['FlightController'] = ResolversParentTypes['FlightController']> = {
  alignment?: Resolver<ResolversTypes['Alignment'], ParentType, ContextType>;
  arming?: Resolver<ResolversTypes['Arming'], ParentType, ContextType>;
  attitude?: Resolver<ResolversTypes['Attitude'], ParentType, ContextType>;
  beeper?: Resolver<ResolversTypes['BeeperConfig'], ParentType, ContextType>;
  blackbox?: Resolver<ResolversTypes['Blackbox'], ParentType, ContextType>;
  features?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  gps?: Resolver<ResolversTypes['GpsData'], ParentType, ContextType>;
  info?: Resolver<ResolversTypes['BoardInfo'], ParentType, ContextType>;
  modes?: Resolver<ResolversTypes['Modes'], ParentType, ContextType>;
  motors?: Resolver<ResolversTypes['MotorsConfig'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  osd?: Resolver<ResolversTypes['OSDConfig'], ParentType, ContextType>;
  pid?: Resolver<ResolversTypes['PidConfig'], ParentType, ContextType>;
  power?: Resolver<ResolversTypes['Power'], ParentType, ContextType>;
  profiles?: Resolver<ResolversTypes['Profiles'], ParentType, ContextType>;
  rc?: Resolver<ResolversTypes['RC'], ParentType, ContextType>;
  sensors?: Resolver<ResolversTypes['Sensors'], ParentType, ContextType>;
  serial?: Resolver<ResolversTypes['SerialConfig'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Status'], ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vtx?: Resolver<ResolversTypes['VtxConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GpsDataResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['GpsData'] = ResolversParentTypes['GpsData']> = {
  fix?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  numSat?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lon?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  alt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  speed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  groundCourse?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobArtifactResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['JobArtifact'] = ResolversParentTypes['JobArtifact']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobDetailsResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['JobDetails'] = ResolversParentTypes['JobDetails']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['JobError']>, ParentType, ContextType>;
  completed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cancelled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  artifact?: Resolver<Maybe<ResolversTypes['JobArtifact']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['JobType'], ParentType, ContextType>;
  connectionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobErrorResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['JobError'] = ResolversParentTypes['JobError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobUpdateResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['JobUpdate'] = ResolversParentTypes['JobUpdate']> = {
  type?: Resolver<ResolversTypes['JobUpdateType'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['JobDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacyBaudRatesResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['LegacyBaudRates'] = ResolversParentTypes['LegacyBaudRates']> = {
  mspBaudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cliBaudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  gpsBaudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  gpsPassthroughBaudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Log'] = ResolversParentTypes['Log']> = {
  time?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModeActivationRangeResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['ModeActivationRange'] = ResolversParentTypes['ModeActivationRange']> = {
  start?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  end?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModeSlotResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['ModeSlot'] = ResolversParentTypes['ModeSlot']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  auxChannel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<ResolversTypes['ModeActivationRange'], ParentType, ContextType>;
  modeLogic?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  linkedTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModesResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Modes'] = ResolversParentTypes['Modes']> = {
  available?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  slots?: Resolver<ReadonlyArray<ResolversTypes['ModeSlot']>, ParentType, ContextType>;
  slot?: Resolver<Maybe<ResolversTypes['ModeSlot']>, ParentType, ContextType, RequireFields<ModesSlotArgs, 'id'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MotorsConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['MotorsConfig'] = ResolversParentTypes['MotorsConfig']> = {
  mixer?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reversedDirection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  digitalIdlePercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  cancelJob?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCancelJobArgs, 'jobId'>>;
  close?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationCloseArgs, 'connectionId'>>;
  connect?: Resolver<ResolversTypes['Connection'], ParentType, ContextType, RequireFields<MutationConnectArgs, 'port' | 'baudRate'>>;
  createFlashDataOffloadJob?: Resolver<ResolversTypes['JobDetails'], ParentType, ContextType, RequireFields<MutationCreateFlashDataOffloadJobArgs, 'connectionId' | 'chunkSize'>>;
  deviceCallibrateAccelerometer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceCallibrateAccelerometerArgs, 'connectionId'>>;
  deviceClearVtxTable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceClearVtxTableArgs, 'connectionId'>>;
  deviceEraseFlashData?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceEraseFlashDataArgs, 'connectionId'>>;
  deviceReset?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceResetArgs, 'connectionId'>>;
  deviceSetArming?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetArmingArgs, 'connectionId' | 'armingDisabled' | 'runawayTakeoffPreventionDisabled'>>;
  deviceSetBlackboxConfig?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetBlackboxConfigArgs, 'connectionId' | 'config'>>;
  deviceSetBoardAlignment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetBoardAlignmentArgs, 'connectionId' | 'alignment'>>;
  deviceSetChannelMap?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetChannelMapArgs, 'connectionId' | 'channelMap'>>;
  deviceSetDigitalIdleSpeed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetDigitalIdleSpeedArgs, 'connectionId' | 'idlePercentage'>>;
  deviceSetDisabledSensors?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetDisabledSensorsArgs, 'connectionId' | 'disabledSensors'>>;
  deviceSetDshotBeeperConfig?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetDshotBeeperConfigArgs, 'connectionId' | 'config'>>;
  deviceSetFeatures?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetFeaturesArgs, 'connectionId' | 'features'>>;
  deviceSetModeSlotConfig?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetModeSlotConfigArgs, 'connectionId' | 'slotId' | 'config'>>;
  deviceSetMotorsDirection?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetMotorsDirectionArgs, 'connectionId' | 'reversed'>>;
  deviceSetOSDAlarm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdAlarmArgs, 'connectionId' | 'alarm'>>;
  deviceSetOSDChar?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdCharArgs, 'connectionId' | 'charIndex' | 'charBytesBuffer'>>;
  deviceSetOSDDisplayItem?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdDisplayItemArgs, 'connectionId' | 'displayItem'>>;
  deviceSetOSDParameters?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdParametersArgs, 'connectionId' | 'parameters'>>;
  deviceSetOSDProfile?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdProfileArgs, 'connectionId' | 'profileIndex'>>;
  deviceSetOSDStatisticItem?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdStatisticItemArgs, 'connectionId' | 'statisticItem'>>;
  deviceSetOSDTimer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdTimerArgs, 'connectionId' | 'timer'>>;
  deviceSetOSDUnitMode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdUnitModeArgs, 'connectionId' | 'unitMode'>>;
  deviceSetOSDVideoSystem?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdVideoSystemArgs, 'connectionId' | 'videoSystem'>>;
  deviceSetOSDWarning?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetOsdWarningArgs, 'connectionId' | 'warning'>>;
  deviceSetPidProtocols?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetPidProtocolsArgs, 'connectionId' | 'protocols'>>;
  deviceSetRcSmoothingConfig?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetRcSmoothingConfigArgs, 'connectionId' | 'smoothingConfig'>>;
  deviceSetReceiverConfig?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetReceiverConfigArgs, 'connectionId' | 'receiverConfig'>>;
  deviceSetRssiChannel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetRssiChannelArgs, 'connectionId' | 'channel'>>;
  deviceSetSerialFunctions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetSerialFunctionsArgs, 'connectionId' | 'portFunctions'>>;
  deviceSetVtxConfig?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetVtxConfigArgs, 'connectionId' | 'vtxConfig'>>;
  deviceSetVtxTableBandsRow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetVtxTableBandsRowArgs, 'connectionId' | 'bandsRow'>>;
  deviceSetVtxTablePowerLevelsRow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeviceSetVtxTablePowerLevelsRowArgs, 'connectionId' | 'powerLevelsRow'>>;
  log?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationLogArgs, 'message'>>;
};

export type OsdAlarmResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDAlarm'] = ResolversParentTypes['OSDAlarm']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDConfig'] = ResolversParentTypes['OSDConfig']> = {
  flags?: Resolver<ResolversTypes['OSDFlags'], ParentType, ContextType>;
  unitMode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  displayItems?: Resolver<ReadonlyArray<ResolversTypes['OSDDisplayItem']>, ParentType, ContextType>;
  statisticItems?: Resolver<ReadonlyArray<ResolversTypes['OSDStatisticItem']>, ParentType, ContextType>;
  warnings?: Resolver<ReadonlyArray<ResolversTypes['OSDWarning']>, ParentType, ContextType>;
  timers?: Resolver<ReadonlyArray<ResolversTypes['OSDTimer']>, ParentType, ContextType>;
  osdProfiles?: Resolver<ResolversTypes['OSDProfileConfig'], ParentType, ContextType>;
  videoSystem?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  alarms?: Resolver<ReadonlyArray<ResolversTypes['OSDAlarm']>, ParentType, ContextType>;
  parameters?: Resolver<ResolversTypes['OSDParameters'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdDisplayItemResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDDisplayItem'] = ResolversParentTypes['OSDDisplayItem']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['OSDPosition'], ParentType, ContextType>;
  visibilityProfiles?: Resolver<ReadonlyArray<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdFlagsResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDFlags'] = ResolversParentTypes['OSDFlags']> = {
  hasOSD?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  haveMax7456Video?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  haveOsdFeature?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOsdSlave?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMax7456Detected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdParametersResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDParameters'] = ResolversParentTypes['OSDParameters']> = {
  cameraFrameWidth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cameraFrameHeight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  overlayRadioMode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdPositionResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDPosition'] = ResolversParentTypes['OSDPosition']> = {
  x?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  y?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdProfileConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDProfileConfig'] = ResolversParentTypes['OSDProfileConfig']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdStatisticItemResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDStatisticItem'] = ResolversParentTypes['OSDStatisticItem']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdTimerResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDTimer'] = ResolversParentTypes['OSDTimer']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  src?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  precision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  time?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OsdWarningResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OSDWarning'] = ResolversParentTypes['OSDWarning']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OffloadJobErrorResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['OffloadJobError'] = ResolversParentTypes['OffloadJobError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PidConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['PidConfig'] = ResolversParentTypes['PidConfig']> = {
  protocols?: Resolver<ResolversTypes['PidProtocols'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PidProtocolsResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['PidProtocols'] = ResolversParentTypes['PidProtocols']> = {
  gyroSyncDenom?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pidProcessDenom?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  useUnsyncedPwm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fastPwmProtocol?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  gyroUse32kHz?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  motorPwmRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Port'] = ResolversParentTypes['Port']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  connecting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  connectionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pnpId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortSettingsResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['PortSettings'] = ResolversParentTypes['PortSettings']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  functions?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  mspBaudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  gpsBaudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  telemetryBaudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blackboxBaudRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PowerResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Power'] = ResolversParentTypes['Power']> = {
  voltage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mahDrawn?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  amperage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PowerLevelsRowResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['PowerLevelsRow'] = ResolversParentTypes['PowerLevelsRow']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfilesResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Profiles'] = ResolversParentTypes['Profiles']> = {
  length?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  configurator?: Resolver<ResolversTypes['Configurator'], ParentType, ContextType>;
  connection?: Resolver<ResolversTypes['Connection'], ParentType, ContextType, RequireFields<QueryConnectionArgs, 'connectionId'>>;
  dummy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  job?: Resolver<Maybe<ResolversTypes['JobDetails']>, ParentType, ContextType, RequireFields<QueryJobArgs, 'id'>>;
  jobs?: Resolver<ReadonlyArray<ResolversTypes['JobDetails']>, ParentType, ContextType, RequireFields<QueryJobsArgs, never>>;
  port?: Resolver<Maybe<ResolversTypes['Port']>, ParentType, ContextType, RequireFields<QueryPortArgs, 'id'>>;
  ports?: Resolver<ReadonlyArray<ResolversTypes['Port']>, ParentType, ContextType>;
};

export type RcResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['RC'] = ResolversParentTypes['RC']> = {
  channels?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  tuning?: Resolver<ResolversTypes['RCTuning'], ParentType, ContextType>;
  smoothing?: Resolver<ResolversTypes['RcSmoothing'], ParentType, ContextType>;
  deadband?: Resolver<ResolversTypes['RCDeadband'], ParentType, ContextType>;
  rssi?: Resolver<ResolversTypes['RcRssi'], ParentType, ContextType>;
  receiver?: Resolver<ResolversTypes['RxConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RcDeadbandResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['RCDeadband'] = ResolversParentTypes['RCDeadband']> = {
  deadband?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yawDeadband?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  altHoldDeadhand?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deadband3dThrottle?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RcTuningResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['RCTuning'] = ResolversParentTypes['RCTuning']> = {
  rcRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rcExpo?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rollPitchRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pitchRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rollRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  yawRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dynamicThrottlePid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  throttleMid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  throttleExpo?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dynamicThrottleBreakpoint?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rcYawExpo?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rcYawRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rcPitchRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rcPitchExpo?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  throttleLimitType?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  throttleLimitPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rollRateLimit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pitchRateLimit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  yawRateLimit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RcRssiResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['RcRssi'] = ResolversParentTypes['RcRssi']> = {
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RcSmoothingResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['RcSmoothing'] = ResolversParentTypes['RcSmoothing']> = {
  channels?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inputCutoff?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  derivativeCutoff?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inputType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  derivativeType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  autoSmoothness?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RxConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['RxConfig'] = ResolversParentTypes['RxConfig']> = {
  serialProvider?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  spi?: Resolver<ResolversTypes['RxSpiConfig'], ParentType, ContextType>;
  channelMap?: Resolver<ReadonlyArray<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RxSpiConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['RxSpiConfig'] = ResolversParentTypes['RxSpiConfig']> = {
  protocol?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SensorsResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Sensors'] = ResolversParentTypes['Sensors']> = {
  available?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  disabled?: Resolver<ReadonlyArray<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SerialConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['SerialConfig'] = ResolversParentTypes['SerialConfig']> = {
  ports?: Resolver<ReadonlyArray<ResolversTypes['PortSettings']>, ParentType, ContextType>;
  legacy?: Resolver<Maybe<ResolversTypes['LegacyBaudRates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatusResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Status'] = ResolversParentTypes['Status']> = {
  cycleTime?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  i2cError?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cpuload?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  jobUpdates?: SubscriptionResolver<ResolversTypes['JobUpdate'], "jobUpdates", ParentType, ContextType, RequireFields<SubscriptionJobUpdatesArgs, never>>;
  onConnectionChanged?: SubscriptionResolver<Maybe<ResolversTypes['ID']>, "onConnectionChanged", ParentType, ContextType, RequireFields<SubscriptionOnConnectionChangedArgs, 'connectionId'>>;
  onReconnecting?: SubscriptionResolver<ResolversTypes['ID'], "onReconnecting", ParentType, ContextType, RequireFields<SubscriptionOnReconnectingArgs, 'connectionId'>>;
};

export type VtxConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['VtxConfig'] = ResolversParentTypes['VtxConfig']> = {
  type?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  band?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  power?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pitMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deviceReady?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lowPowerDisarm?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pitModeFrequency?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['VtxTableConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VtxTableConfigResolvers<ContextType = ApolloContext, ParentType extends ResolversParentTypes['VtxTableConfig'] = ResolversParentTypes['VtxTableConfig']> = {
  numBandChannels?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numPowerLevels?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  powerLevels?: Resolver<ReadonlyArray<ResolversTypes['PowerLevelsRow']>, ParentType, ContextType>;
  powerLevel?: Resolver<Maybe<ResolversTypes['PowerLevelsRow']>, ParentType, ContextType, RequireFields<VtxTableConfigPowerLevelArgs, 'id'>>;
  numBands?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bands?: Resolver<ReadonlyArray<ResolversTypes['BandsRow']>, ParentType, ContextType>;
  band?: Resolver<Maybe<ResolversTypes['BandsRow']>, ParentType, ContextType, RequireFields<VtxTableConfigBandArgs, 'id'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = ApolloContext> = {
  Alignment?: AlignmentResolvers<ContextType>;
  Arming?: ArmingResolvers<ContextType>;
  Attitude?: AttitudeResolvers<ContextType>;
  BandsRow?: BandsRowResolvers<ContextType>;
  BeeperConfig?: BeeperConfigResolvers<ContextType>;
  Blackbox?: BlackboxResolvers<ContextType>;
  BlackboxConfig?: BlackboxConfigResolvers<ContextType>;
  BlackboxFlash?: BlackboxFlashResolvers<ContextType>;
  BlackboxSdCard?: BlackboxSdCardResolvers<ContextType>;
  BoardInfo?: BoardInfoResolvers<ContextType>;
  Configurator?: ConfiguratorResolvers<ContextType>;
  Connection?: ConnectionResolvers<ContextType>;
  DshotBeeperConfig?: DshotBeeperConfigResolvers<ContextType>;
  FlightController?: FlightControllerResolvers<ContextType>;
  GpsData?: GpsDataResolvers<ContextType>;
  JobArtifact?: JobArtifactResolvers<ContextType>;
  JobDetails?: JobDetailsResolvers<ContextType>;
  JobError?: JobErrorResolvers<ContextType>;
  JobUpdate?: JobUpdateResolvers<ContextType>;
  LegacyBaudRates?: LegacyBaudRatesResolvers<ContextType>;
  Log?: LogResolvers<ContextType>;
  ModeActivationRange?: ModeActivationRangeResolvers<ContextType>;
  ModeSlot?: ModeSlotResolvers<ContextType>;
  Modes?: ModesResolvers<ContextType>;
  MotorsConfig?: MotorsConfigResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  OSDAlarm?: OsdAlarmResolvers<ContextType>;
  OSDConfig?: OsdConfigResolvers<ContextType>;
  OSDDisplayItem?: OsdDisplayItemResolvers<ContextType>;
  OSDFlags?: OsdFlagsResolvers<ContextType>;
  OSDParameters?: OsdParametersResolvers<ContextType>;
  OSDPosition?: OsdPositionResolvers<ContextType>;
  OSDProfileConfig?: OsdProfileConfigResolvers<ContextType>;
  OSDStatisticItem?: OsdStatisticItemResolvers<ContextType>;
  OSDTimer?: OsdTimerResolvers<ContextType>;
  OSDWarning?: OsdWarningResolvers<ContextType>;
  OffloadJobError?: OffloadJobErrorResolvers<ContextType>;
  PidConfig?: PidConfigResolvers<ContextType>;
  PidProtocols?: PidProtocolsResolvers<ContextType>;
  Port?: PortResolvers<ContextType>;
  PortSettings?: PortSettingsResolvers<ContextType>;
  Power?: PowerResolvers<ContextType>;
  PowerLevelsRow?: PowerLevelsRowResolvers<ContextType>;
  Profiles?: ProfilesResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RC?: RcResolvers<ContextType>;
  RCDeadband?: RcDeadbandResolvers<ContextType>;
  RCTuning?: RcTuningResolvers<ContextType>;
  RcRssi?: RcRssiResolvers<ContextType>;
  RcSmoothing?: RcSmoothingResolvers<ContextType>;
  RxConfig?: RxConfigResolvers<ContextType>;
  RxSpiConfig?: RxSpiConfigResolvers<ContextType>;
  Sensors?: SensorsResolvers<ContextType>;
  SerialConfig?: SerialConfigResolvers<ContextType>;
  Status?: StatusResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  VtxConfig?: VtxConfigResolvers<ContextType>;
  VtxTableConfig?: VtxTableConfigResolvers<ContextType>;
};

